import React from "react";
import { Container, ContainerFluid } from "../components/Wrapper.js";
import Header from "../components/headers/Header.js";
import Footer from "../components/footers/Footer.js";
import Cseries from "../components/Cseries.js";

export default function CseriesPage(){
  return (
    <Container>
      <Header isActiveTab="3" />
      <ContainerFluid>
        <Cseries />
      </ContainerFluid>
      <ContainerFluid>
        <Footer />
      </ContainerFluid>
    </Container>
  );
};